import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSalaryPerformanceBaseInfoListDataApi(data) {
  return request({
    url: 'tms-web/salaryPerformanceBaseInfo/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSalaryPerformanceBaseInfoListDataApi(data) {
  return request({
    url: 'tms-web/salaryPerformanceBaseInfo/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveSalaryPerformanceBaseInfoApi(data) {
  return request({
    url: 'tms-web/salaryPerformanceBaseInfo/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteSalaryPerformanceBaseInfoApi(data) {
  return request({
    url: 'tms-web/salaryPerformanceBaseInfo/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewSalaryPerformanceBaseInfoApi(data) {
  return request({
    url: 'tms-web/salaryPerformanceBaseInfo/view',
    method: 'post',
    data
  })
}

// 列表
export function listSalaryPerformanceBaseInfoApi(data) {
  return request({
    url: 'tms-web/salaryPerformanceBaseInfo/list',
    method: 'post',
    data
  })
}
